import { api } from "@/services/api"
import { useQuery } from "@tanstack/vue-query"
import type { MaybeRef } from "vue"

export type ListCustomersResponseItem = {
  id: string
  name: string
  email: string
  phone: string
  description: string
  totalPayments: number
  createdByUser?: string
}

export type ListCustomersFilter = {
  search?: string
}

export type ListCustomersOrdering = "name" | "-name"

export type ListCustomersQuery = ListCustomersFilter & {
  ordering?: ListCustomersOrdering
} & Pagination

const listCustomers = async (
  query?: ListCustomersQuery
): Promise<Paginate<ListCustomersResponseItem[]>> => {
  const { body } = await api.get<
    RecursivelyConvertDatesToStrings<
      Paginate<ListCustomersResponseItem[]>
    >
  >("/services/customers/", { query })

  return body
}

export const useCustomers = (
  query?: MaybeRef<ListCustomersQuery>
) =>
  useQuery({
    queryKey: [CUSTOMERS_QUERY_KEY, query] as const,
    queryFn: ({ queryKey: [_, query_] }) =>
      listCustomers(query_),
  })
